import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../../App";
// import "./AuditionCardReuse.css";

const StarMarkTable = (props) => {
  const { videoCdnUrl } = useContext(serverInfo);

  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 4;
  const { data, handleSelectedVideo, myGroup } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="py-3">
        <div className="row justify-content-md-between justify-content-lg-center">
          {currentItems.map((video, index) => {
            return (
              <div
                key={index}
                className="col-sm-12 col-md-6 col-lg-3 mb-3"
                onClick={() => handleSelectedVideo(video)}
                style={{
                  height: "200px",
                  width: "290px",
                }}
              >
                <div className="">
                  <ReactPlayer
                    height={190}
                    width={260}
                    style={{ cursor: "pointer" }}
                    controls
                    url={
                      video?.judge_videos?.video != null
                        ? videoCdnUrl + video?.judge_videos?.video
                        : ""
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div id="react-paginate" className="mt-3">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};

export default StarMarkTable;
